import ReportTemplateCollectorNoClick from './ReportTemplateCollectorNoClick';
import { formatDateTime } from '../Utilities/GridTools';


const CollectorNotes = () => {
    

    const columns = [
        { field: 'debtorID', headerName: 'Debtor ID', width: 120 },
        { field: 'time', headerName: 'date', width: 180, valueFormatter: formatDateTime, filter: 'agDateColumnFilter' },
        { field: 'projectID',headerName: 'Project', width: 150 },
        { field: 'debtorStatus', headerName: 'Debtor Status', width: 100 },
        { field: 'comments', headerName: 'Comments', width: 400 },
    ];

    const apiUrl = `${process.env.REACT_APP_API_URL}/Reports/GetNotesByCollector`;

    return (
       <ReportTemplateCollectorNoClick columnDefs={columns} apiUrl={apiUrl} reportName={'Collector Notes'} />
    );
};

export default CollectorNotes;